import { Projectile } from '../../../domain/projectile.js';

function pushProjectile(activeProjectiles, pDomain, pMesh, scene) {
  if (pMesh && scene) scene.add(pMesh);
  activeProjectiles.push({ domain: pDomain, mesh: pMesh });
}

function fireQFlurry(championEntity, target, activeProjectiles, createFrostArrowMeshCallback, scene) {
  for (let i = 0; i < 5; i++) {
    const pDomain = new Projectile({
      id: `q-arrow-${Date.now()}-${i}`,
      sourceEntity: championEntity,
      targetEntity: target,
      speed: 1300 + i * 80,
      damage: (championEntity.ad * 1.25) / 5
    });
    const pMesh = createFrostArrowMeshCallback ? createFrostArrowMeshCallback(true) : null;
    const offsetPerp = (i - 2) * 0.35;
    const perpAngle = championEntity.facingAngle + Math.PI / 2;
    pDomain.x += Math.cos(perpAngle) * offsetPerp;
    pDomain.z += Math.sin(perpAngle) * offsetPerp;
    pushProjectile(activeProjectiles, pDomain, pMesh, scene);
  }
}

function fireBasicShot(championEntity, attackEvent, activeProjectiles, createFrostArrowMeshCallback, scene) {
  const critMultiplier = attackEvent.isCrit ? 2.0 : 1.0;
  const effectiveAd = championEntity.getEffectiveStats().ad;
  const pDomain = new Projectile({
    id: `arrow-${Date.now()}`,
    sourceEntity: championEntity,
    targetEntity: attackEvent.target,
    speed: 1500,
    damage: effectiveAd * critMultiplier,
    isCrit: attackEvent.isCrit
  });
  const pMesh = createFrostArrowMeshCallback ? createFrostArrowMeshCallback(false) : null;
  pushProjectile(activeProjectiles, pDomain, pMesh, scene);
}

function resolveChampionAttack(championEntity, dt, activeProjectiles, createFrostArrowMeshCallback, scene) {
  if (!championEntity) return;
  const attackEvent = championEntity.updateAttackCycle(dt);
  if (!attackEvent.fired || !attackEvent.target || attackEvent.target.isDead) return;
  if (attackEvent.isQFlurry) {
    fireQFlurry(championEntity, attackEvent.target, activeProjectiles, createFrostArrowMeshCallback, scene);
  } else {
    fireBasicShot(championEntity, attackEvent, activeProjectiles, createFrostArrowMeshCallback, scene);
  }
}

/**
 * Champion auto-attack / Q-flurry → projectiles (player + secondaries).
 */
export function updateChampionAttacks({
  championEntity,
  secondaries = [],
  dt = 0,
  activeProjectiles = [],
  createFrostArrowMeshCallback = null,
  scene = null
} = {}) {
  resolveChampionAttack(championEntity, dt, activeProjectiles, createFrostArrowMeshCallback, scene);
  for (const secondary of secondaries) {
    resolveChampionAttack(secondary, dt, activeProjectiles, createFrostArrowMeshCallback, scene);
  }
}
